<template>
  <div
    class="filter-categories"
    :class="{
      'filter-categories--start': arrivedState.left,
      'filter-categories--end': arrivedState.right,
    }"
  >
    <div
      v-if="categoryList.length > 0"
      class="filter-categories__container"
    >
      <ul
        ref="categories"
        class="filter-categories__list"
      >
        <li
          v-for="option in categoryList"
          :key="option"
          class="filter-categories__item"
        >
          <AppLink
            :to="matchUrl(option)"
            class="filter-categories__link button button--secondary"
            :class="{
              'filter-categories__link--active': option?.active,
            }"
          >
            {{ option?.label }}
          </AppLink>
        </li>
        <li
          v-if="outlet"
          class="filter-categories__item"
        >
          <button
            class="filter-outlet__link button button--secondary"
            :class="{
              'filter-outlet__link--active': outletActive,
            }"
            @click.prevent="toggleOutlet"
          >
            {{ outletFilter.label }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
const meta = inject('meta', ref())

const {
  categoryFilters,
  outletFilter,
} = useCatalogFilters(meta)

const categories = ref<HTMLElement | null>(null)

const { arrivedState } = useScroll(categories)

const getActiveSubcategories = (categories: any) => {
  const activeCat = categories?.find(cat => cat.active)
  let subCat = null

  if (activeCat && activeCat?.children?.length) {
    subCat = getActiveSubcategories(activeCat?.children)
  }

  return subCat || categories
}

const categoryList = computed(() => {
  return getActiveSubcategories(categoryFilters?.value?.options) || { children: categoryFilters?.value?.options }
})

const matchUrl = (option) => {
  const { urlPath } = option

  let baseUrl = meta?.value?.url
  const urlFilters = meta?.value?.filters || []

  if (!baseUrl) {
    return `/${urlPath}/`
  }

  if (urlFilters.length === 1) {
    baseUrl = ''
  }

  if (baseUrl.startsWith('merken/')) {
    return '/' + baseUrl + '/?filter=1&cat=' + option.key
  }

  const regex = urlPath + ' ' + baseUrl + '/'
  const match = regex.match(/^(\S*\/)\S*(?: \1\S*)*$/)

  if (!match) {
    return '/' + (baseUrl ? baseUrl.split('/')[0] : '') + '/' + urlPath
  }

  return '/' + urlPath + '/'
}

const router = useRouter()
const route = useRoute()
const outlet = computed(() => meta.value.page_type === 'plp-brand'
  && outletFilter.value?.options.length > 0)
const outletActive = computed(() => outlet.value && !!route.query.is_outlet)
const toggleOutlet = () => {
  if (outletActive.value) {
    // Remove 'is_outlet' from query params
    const { is_outlet, ...restQuery } = route.query
    router.push({
      path: route.path,
      query: restQuery,
    })
  }
  else {
    router.push({
      path: route.path,
      query: {
        ...route.query,
        filter: '1',
        is_outlet: '1',
      },
    })
  }
}
</script>

<!-- <style src="~layers/app/components/Filter/Categories.css" /> -->
<style>
@import url("~layers/app/components/Filter/Categories.css");
</style>
